import { ChatInboxWorkspace } from '@/features/ChatInbox/ui/ChatInboxWorkspace';

/** Открывает общую переписку по прежней ссылке внешнего диалога */
export const ChatDialogPage = () => <ChatInboxWorkspace initialSource="salebot" />;
